module.exports = __webpack_public_path__ + "static/media/Screen Shot 2023-02-20 at 12.27.00@2x.0795731e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screen Shot 2023-02-20 at 12.27.00@2x.png
// module id = 568
// module chunks = 1